<template>
  <v-app>
    <v-app-bar
      app
      :inverted-scroll="$route.path != '/karrier-telepites-vezeto'"
      color="white">
      <v-row class="max-width-1200 mx-auto">
        <v-col cols="2" class="mt-1 ml-1 px-0">
          <div class="d-flex align-center">
            <v-card
              flat color="transparent"
              :ripple="false"
              class="d-flex"
              style="min-width:210px;padding:6px;"
              @click="loadPage('Home')">
              <span><img
                alt="Rubin Infomatika logó"
                class="shrink mr-2"
                contain
                src="@/assets/logo-grad-ruby.svg"
                transition="scale-transition"
                height="24" width="24"></span>
              <span class="brand-title pr-2" style="margin-top:2px;">{{ $t('rubin.rubin') }}</span>
              <span class="brand-subtitle" style="margin-top:8px;">{{ $t('rubin.informatic') }}</span>
            </v-card>
          </div>
        </v-col>

        <v-spacer></v-spacer>

        <v-col v-if="!mini" cols="8" class="pt-4 text-end">
          <!-- <v-btn
            class="mr-2"
            text
            @click="loadPage('Home')">
              {{ $t('common.home') }}
          </v-btn> -->
          <v-btn
            text
            @click="loadPage('RubinAbout')">
              {{ $t('common.rubinAbout') }}
          </v-btn>
          <v-btn
            text
            @click="loadPage('ItSolutions')">
              {{ $t('service.itSolutions.title') }}
          </v-btn>
          <v-btn
            text
            @click="loadPage('EnergyManagement')">
              {{ $t('service.ernergyManagement.title') }}
          </v-btn>
          <v-btn
            text
            @click="loadPage('Hardware')">
            {{ $t('service.hardware.title') }}
          </v-btn>
          <!-- <v-btn
            class="mr-2"
            text
            @click="loadPage('Articles')">
            Articles
          </v-btn>
          <v-btn
            class="mr-2"
            text
            @click="loadPage('Design')">
            Design
          </v-btn> -->
        </v-col>
        <v-col v-if="mini" class="pt-2 pr-0 text-end">
          <v-btn
            id="btn_menu"
            title="menu"
            name="menu"
            icon
            class="animate__animated"
            @click="openMenu()">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </v-col>
        <!-- language select -->
        <div class="langSelectMenuBtnDiv pt-2">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                light icon
                title="language"
                name="language"
                v-bind="attrs"
                v-on="on">
                <!-- <v-img :src="$store.getters.selectedLanguage.flag" max-width="16"></v-img> -->
                <v-img :src="selectedLanguageDetails.flag" max-width="16"></v-img>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in language.items"
                :key="index"
                @click="changeLanguage(item)">
                <v-list-item-title><v-img :alt="item.value" :src="item.flag" width="16"></v-img></v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="$route.path.endsWith('/energia-monitor')"
                @click="setLangDe(true)">
                <v-list-item-title><v-img src="@/assets/flag-de.png" width="16"></v-img></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-row>

      <v-dialog
        v-model="fullscreenMenu"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition">
        <v-card color="primary">
          <v-toolbar flat color="primary">
            <v-spacer></v-spacer>
            <v-btn
              icon dark
              @click="closeMenu()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-row class="justify-center align-center">
            <v-btn
              class="mr-2"
              text dark block
              @click="openPage('RubinAbout')">
              {{ $t('common.rubinAbout') }}
            </v-btn>
            <v-btn
              class="mr-2"
              text dark block
              @click="openPage('ItSolutions')">
              {{ $t('service.itSolutions.title') }}
            </v-btn>
            <v-btn
              class="mr-2"
              text dark block
              @click="openPage('EnergyManagement')">
              {{ $t('service.ernergyManagement.title') }}
            </v-btn>
            <v-btn
              class="mr-2"
              text dark block
              @click="openPage('Hardware')">
              {{ $t('service.hardware.title') }}
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>

    </v-app-bar>

    <v-main>
      <!-- skeleton - home -->
      <v-row v-if="loading">
        <v-col class="pt-0">
          <v-row>
            <v-col class="pt-0">
              <v-skeleton-loader
                :loading="loading"
                transition="fade-transition"
                :style="'height:' + (computedPageHeight - 150) + 'px'"
                type="image">
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="mt-4 mx-4">
            <v-col>
              <v-skeleton-loader
                :loading="loading"
                transition="fade-transition"
                type="paragraph">
              </v-skeleton-loader>
            </v-col>
            <v-col>
              <v-skeleton-loader
                :loading="loading"
                transition="fade-transition"
                type="paragraph">
              </v-skeleton-loader>
            </v-col>
            <v-col>
              <v-skeleton-loader
                :loading="loading"
                transition="fade-transition"
                type="paragraph">
              </v-skeleton-loader>
            </v-col>
            <v-col>
              <v-skeleton-loader
                :loading="loading"
                transition="fade-transition"
                type="paragraph">
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- page  -->
      <router-view v-if="loaded"></router-view>
    </v-main>

  </v-app>
</template>

<script>
import DataComponentBase from '@/commons/DataComponentBase';

export default {
  name: 'App',
  extends: DataComponentBase,

  components: {
  },

  data() {
    return {
      loading: true,
      loaded: false,
      fullscreenMenu: false,
    }
  },

  created() {
    const readyHandler = () => {
      if (document.readyState == 'complete') {
          this.loading = false;
          this.loaded = true;
          document.removeEventListener('readystatechange', readyHandler);
      }
    };

    document.addEventListener('readystatechange', readyHandler);

    readyHandler(); // in case the component has been instantiated lately after loading
  },

  computed: {
    mini() {
      if (this.computedWidth < 1000) {
        return true
      } else {
        return false
      }
    },
  },

  methods: {
    openMenu() {
      this.fullscreenMenu = true;
    },
    closeMenu() {
      this.fullscreenMenu = false;
    },
    openPage(route) {
      this.loadPage(route);
      this.closeMenu();
    },

  },
};
</script>
